/**
 * Табы в профиле пользователя
 */
export enum DesignerTab {
  //projects = 'projects',
  students = 'students',
  author = 'projects',
  workingMaterials = 'working_materials',
  workingMaterialsAuthor = 'working_materials_author',
  workingMaterialsCoauthor = 'working_materials_coauthor',
  workingMaterialsStudents = 'working_materials_students',
  coauthor = 'coauthor',
  bookmarks = 'bookmarks',
  drafts = 'drafts',
  underModeration = 'under_moderation',
  moder = 'moder',
  otherDrafts = 'other_drafts',
  hselabProjects = 'hselab_projects',
  books = "books",
  draftBooks = 'draft_books',
  bannedProjects = 'banned_projects',
  hseillustrationProjects = 'hseillustration_projects',
  hsedesigntemp = 'hsedesigntemp',
  competitions = 'competitions',
  presentations = 'presentations',
  draftPsn = 'draft_presentation',
  rejected = 'rejected',
  organizations = 'organizations',
  private = 'private',
  games_archive = 'games_archive',
  games_drafts = 'games_drafts',
  lms = 'lms_profile',
  lmsDrafts = 'lms_drafts',
  jury = 'jury',
  aboutMe = 'aboutMe',
  subscriptionsProjects = 'subscriptionsProjects',
  discount = 'discount',
  subscribe = 'subscribe',
  subscribers = 'subscribers',
  subscriptions = 'subscriptions',
  competitionCerts = 'competitionCerts',
  educationSubscribes = 'educationSubscribes'
}

export const PROFILE_TABS_IN_ORDER: DesignerTab[] = [
  DesignerTab.author,
  DesignerTab.students,
  DesignerTab.coauthor,
  DesignerTab.workingMaterials,
  DesignerTab.books,
  DesignerTab.organizations,
  DesignerTab.jury,
  DesignerTab.aboutMe,
  DesignerTab.presentations,
  DesignerTab.hseillustrationProjects,
  DesignerTab.subscribe,
  DesignerTab.competitionCerts,
]

export const PROFILE_TABS_ME_IN_ORDER: DesignerTab[] = [
  DesignerTab.competitions,
  DesignerTab.bookmarks,
  DesignerTab.drafts,
  DesignerTab.draftBooks,
  DesignerTab.bannedProjects,
  DesignerTab.private,
  DesignerTab.lms,
  DesignerTab.lmsDrafts,
  DesignerTab.underModeration,
  DesignerTab.discount,
]


export const PROFILE_TABS_WORKING_MATERIALS: DesignerTab[] = [
  DesignerTab.workingMaterialsAuthor,
  DesignerTab.workingMaterialsStudents,
  DesignerTab.workingMaterialsCoauthor,
]

export const PROFILE_TABS_SUBSCRIBE: DesignerTab[] = [
  DesignerTab.subscribe,
  DesignerTab.subscriptions,
  DesignerTab.subscribers,
  DesignerTab.subscriptionsProjects,
]
/**
 * Табы в профиле пользователя
 */
export enum DesignerTab {
  //projects = 'projects',
  students = 'students',
  author = 'projects',
  workingMaterials = 'working_materials',
  workingMaterialsAuthor = 'working_materials_author',
  workingMaterialsCoauthor = 'working_materials_coauthor',
  workingMaterialsStudents = 'working_materials_students',
  coauthor = 'coauthor',
  bookmarks = 'bookmarks',
  drafts = 'drafts',
  underModeration = 'under_moderation',
  moder = 'moder',
  otherDrafts = 'other_drafts',
  hselabProjects = 'hselab_projects',
  books = "books",
  draftBooks = 'draft_books',
  bannedProjects = 'banned_projects',
  hseillustrationProjects = 'hseillustration_projects',
  hsedesigntemp = 'hsedesigntemp',
  competitions = 'competitions',
  presentations = 'presentations',
  draftPsn = 'draft_presentation',
  rejected = 'rejected',
  organizations = 'organizations',
  private = 'private',
  games_archive = 'games_archive',
  games_drafts = 'games_drafts',
  lms = 'lms_profile',
  lmsDrafts = 'lms_drafts',
  jury = 'jury',
  aboutMe = 'aboutMe',
  subscriptionsProjects = 'subscriptionsProjects',
  discount = 'discount',
  subscribe = 'subscribe',
  subscribers = 'subscribers',
  subscriptions = 'subscriptions',
  competitionCerts = 'competitionCerts',
  educationSubscribes = 'educationSubscribes'
}

export const PROFILE_TABS_IN_ORDER: DesignerTab[] = [
  DesignerTab.author,
  DesignerTab.students,
  DesignerTab.coauthor,
  DesignerTab.workingMaterials,
  DesignerTab.books,
  DesignerTab.organizations,
  DesignerTab.jury,
  DesignerTab.aboutMe,
  DesignerTab.presentations,
  DesignerTab.hseillustrationProjects,
  DesignerTab.subscribe,
  DesignerTab.competitionCerts,
]

export const PROFILE_TABS_ME_IN_ORDER: DesignerTab[] = [
  DesignerTab.competitions,
  DesignerTab.bookmarks,
  DesignerTab.drafts,
  DesignerTab.draftBooks,
  DesignerTab.bannedProjects,
  DesignerTab.private,
  DesignerTab.lms,
  DesignerTab.lmsDrafts,
  DesignerTab.underModeration,
  DesignerTab.discount,
]


export const PROFILE_TABS_WORKING_MATERIALS: DesignerTab[] = [
  DesignerTab.workingMaterialsAuthor,
  DesignerTab.workingMaterialsStudents,
  DesignerTab.workingMaterialsCoauthor,
]

export const PROFILE_TABS_SUBSCRIBE: DesignerTab[] = [
  DesignerTab.subscribe,
  DesignerTab.subscriptions,
  DesignerTab.subscribers,
  DesignerTab.subscriptionsProjects,
]
